import { Toaster } from "sonner";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { router } from "./App.tsx";
import "./index.css";
import { instrumentRouter } from "./lib/faro.ts";

// Instrumenta o router com Faro (se habilitado)
const instrumentedRouter = instrumentRouter(router);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 15_000,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-right" richColors closeButton />
      <RouterProvider router={instrumentedRouter} />
    </QueryClientProvider>
  </StrictMode>,
);
